var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.bookings,"items-per-page":200,"hide-default-footer":"","calculate-widths":""},scopedSlots:_vm._u([{key:"item.candidate",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.candidate.name))]}},{key:"item.client",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.client.name))]}},{key:"item.site",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.site.city))]}},{key:"item.amount",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.toCurrency(item.amount)))]}},{key:"item.wage",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.toCurrency(item.wage)))]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }